import * as e from "react";
const o = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...t }, /* @__PURE__ */ e.createElement("path", { d: "M4 1H3v22h18V6.6l-.3-.3-5-5-.3-.3H4zm1 20V3h9v5h5v13H5zM17.6 6L16 4.4V6h1.6zM11 8v6.7l-2.3-2.1L7.3 14l4 3.7.7.7.7-.7 4-3.7-1.4-1.4-2.3 2.1V8h-2z", clipRule: "evenodd" }));
export {
  o as ReactComponent
};
